import React from 'react';
import classNames from 'classnames/bind';
import styles from './OTPInput.module.scss';
import { AnyCnameRecord } from 'dns';

type Props = {
  name?: string;
  value?: string;
  hasError?: boolean;
  onChange: (e: any) => void;
  onBlur?: (e:any) => void;
};

const OtpInput = ({ name, value, hasError, onChange, onBlur }: Props) => {
  return (
    <input
      type="number"
      name={name}
      value={value}
      maxLength={1}
      onChange={(e: any) => onChange(e)}
      className={classNames(
        styles.input,
        value && styles.hasValue,
        hasError && styles.hasError,
      )}
      onBlur={onBlur}
    />
  );
};

export default OtpInput;
